// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { memo, useEffect, useRef, useState } from "react";
import RecentDashboardBox from "../tooltip/RecentDashboardBox";

const RecentsListBar = ({
  dashboards,
  afterLandDashboard,
  top = 0,
  left = 40,
  onEnter,
  onClose,
  showTitle = true,
}) => {
  const panelRef = useRef(null);
  const [offset, setOffset] = useState(top);

  useEffect(() => {
    const height = panelRef.current?.offsetHeight || 0;
    const maxTop = window.innerHeight - height - 8;
    setOffset(Math.max(8, Math.min(top, maxTop)));
  }, [top, dashboards]);

  return (
    <div
      className="dashboard-flyout flex items-start fixed"
      style={{ top: offset, left: left + 2 }}
      onMouseEnter={() => {
        if (onEnter) onEnter();
      }}
      onMouseLeave={() => {
        if (onClose) onClose();
      }}
    >
      <div
        ref={panelRef}
        className="font-geist flex flex-col z-[1000] w-72 max-h-[calc(100vh-16px)] bg-card-card rounded-lg shadow-xl outline outline-1 outline-general-border overflow-hidden"
      >
        {showTitle && (
          <div className="flex h-8 w-full shrink-0 items-center border-b border-general-border px-3 text-left text-general-muted-foreground text-xs font-medium">
            {"Recents"}
          </div>
        )}

        <div className="flex-1 max-h-[268px] overflow-y-auto overscroll-contain overflow-x-hidden py-1 flex flex-col justify-start items-start app-scrollbar">
          {dashboards?.length > 0 ? (
            dashboards.map((dashboard) => (
              <RecentDashboardBox
                key={dashboard?._id}
                dashboard={dashboard}
                afterlandDashboardNew={afterLandDashboard}
              />
            ))
          ) : (
            <div className="self-stretch px-3 py-2 text-general-muted-foreground text-sm font-normal leading-5">
              {"No dashboards found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(RecentsListBar);
